<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<!-- Material Look-n-Feel -->
<div class="tiny-ticket-wrapper wrap-relative wbs-code-container">
	<mat-form-field class="full-width" subscriptSizing="dynamic">
		<mat-label>{{ appStrings.WBS_CODE }}</mat-label>
		<input
			matInput
			class="wbs-code-input"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
			[formControl]="internalField"
		/>
	</mat-form-field>
</div>
